import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { ApiResponse, SubCategoryCriteria, SubCategoryDto } from '../objects';
import { moduleConfigToken, AbdaliModuleConfig } from '../app.module';

@Injectable()
export class SubCategoryService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    getSubCategories(criteria: SubCategoryCriteria, headers?: HttpHeaders) {
        let endpoint = '/api/v1/sub-category';
        endpoint = `${endpoint}?categoryId=${criteria.categoryId ? criteria.categoryId : ''}`;
        if (criteria.name) {
            endpoint = `${endpoint}&name=${criteria.name}`;
        }

        return this.getAll(endpoint, headers);
    }

    getSubCategoryById(subCatId: number, headers?: HttpHeaders) {
        const endpoint = '/api/v1/sub-category';
        return this.getById(endpoint, subCatId, headers);
    }

    insert(dto: SubCategoryDto, file?: File, headers?: HttpHeaders) {
        const endpoint = '/api/v1/sub-category';
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }

        dto.description = dto.description == null ? '' : dto.description;
        dto.name = dto.name == null ? '' : dto.name;
        dto.searchField = dto.searchField == null ? '' : dto.searchField;

        const formData = new FormData();
        formData.append('name', dto.name);
        formData.append('categoryId', dto.categoryId.toString());
        formData.append('description', dto.description);
        formData.append('searchField', dto.searchField.toString());
        if (file) {
            formData.append('files', file, file.name);
        }
        
        return this.post(endpoint, formData, headers);
    }

    update(dto: SubCategoryDto, file?: File, headers?: HttpHeaders) {
        const endpoint = '/api/v1/sub-category';
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }

        dto.description = dto.description == null ? '' : dto.description;
        dto.name = dto.name == null ? '' : dto.name;
        dto.searchField = dto.searchField == null ? '' : dto.searchField;

        const formData = new FormData();
        formData.append('name', dto.name);
        formData.append('id', dto.id.toString());
        formData.append('categoryId', dto.categoryId.toString());
        formData.append('description', dto.description);
        formData.append('searchField', dto.searchField.toString());
        if (file) {
            formData.append('files', file, file.name);
        }

        return this.put(endpoint, formData, headers);
    }

}
